import { get } from "lodash";
import { Helpers } from "../../utils/helper";


// This modal are used for Document listing api.
export class DocumentItem{
  label         : string;
  code          : string;
  description   : string;
  checkbox      : boolean;
  checkbox_label: string;
  sample        : string;
  alert_content?: string;
  constructor(initial?:DocumentItem){
    this.label            = get(initial, 'label', '');
    this.code             = get(initial, 'code', '');
    this.description      = get(initial, 'description', '');
    this.checkbox         = get(initial, 'checkbox', false);
    this.checkbox_label   = get(initial, 'checkbox_label', '');
    this.sample           = get(initial, 'sample', '');
    this.alert_content    = get(initial, 'alert_content', '');
  }
}




// this modal are used for to store a list of FileItems array
export class FileItem{
  label?      : string;
  file_id     : string;
  code        : string;
  file_content:FileContent;
  file?       : File;
  key         : string;
  submitted_date : string;
  uinfin      : string;
  is_error: boolean;

  constructor(initial?:any){
    this.file_id      = get(initial, 'file_id', "");
    this.code         = get(initial, 'code', "");
    this.file_content = get(initial, 'file_content', new FileContent(initial) );
    this.label = get(initial, 'label', "" );
    this.file = get(initial, 'file', undefined);
    this.key  = get(initial, 'key', "");
    this.submitted_date = get(initial, 'submitted_date', "");
    this.uinfin = get(initial, "uinfin", "");
    this.is_error = get(initial, 'is_error', false);
  }

  setIsError(isError: boolean){
    this.is_error = isError;
  }

  setFileId(file_id: string){
    this.file_id = file_id;
  }
  setFileInfo(file: File){
    this.file_content = new FileContent({
      ...this.file_content,
      file_name:file?.name,
      size:file?.size,
      document_type: Helpers.stripMimeType(file?.type),
    })
  }
  setFileBase64(base64: string){
    this.file_content = new FileContent({
      ...this.file_content,
      file_base_64: base64
    })
  }

  setSubmittedDate(submitted_date: string){
    this.submitted_date = submitted_date;
  }

  setKey(key: string){
    this.key = key;
  }
}

export class FileContent{
  id: string;
  file_name?:string;
  size?:number;
  document_type?: string;
  file_base_64?: string | ArrayBuffer | null;
  constructor(initial?:FileContent){
    this.id = get(initial, 'id', Helpers.generateAlphaNumericID()); //auto generae alphanumeric as ID when selected a file;
    this.file_name = get(initial, 'file_name', '');
    this.size = get(initial, 'size', 0);
    this.document_type = get(initial, 'document_type', '');
    this.file_base_64 = get(initial, 'file_base_64', '');
  }
}
